import * as React from 'react'

import { TentacleErrorData } from 'modules/core/lib/parseErrorData'

import { default as ChartCanvas } from 'modules/reports/components/Chart'
import TableWrapper from 'modules/reports/components/Chart/TableWrapper'
import type ReportStruct from 'modules/reports/lib/ReportStruct'
import type { ResourceData } from 'modules/reports/store/models/Resource'

interface ChartEditorProps {
  loading: boolean
  data: ResourceData | undefined
  error?: TentacleErrorData | Error
  reportStruct: ReportStruct
  hasTable: boolean
}

const Chart = ({ data, error, reportStruct, loading, hasTable }: ChartEditorProps) => {
  return (
    <TableWrapper data={data?.rows} reportStruct={reportStruct} hasTable={hasTable}>
      <ChartCanvas
        data={data}
        error={error}
        reportStruct={reportStruct}
        showLegend
        loading={loading}
        reduceMargins={false}
      />
    </TableWrapper>
  )
}

export default Chart
